import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const create = async function(data) {
    const {userId, displayName, password, shouldSendEmail} = data;   
    const user = {
        userId,
        displayName,
        password,
        shouldSendEmail
    };
    return apiService.post('user', user);
}

export default {
    create,
}